// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".last-run-column--lastRunColumn--1ffU9lMQ {\n  background: transparent;\n  height: auto;\n  max-width: 82px;\n  padding: 0;\n  width: 82px;\n  word-wrap: break-word;\n}\n.last-run-column--lastRunColumn--1ffU9lMQ .last-run-column--even--2i5Vwx_m {\n  background-color: white;\n}\n.last-run-column--lastRunColumn--1ffU9lMQ .last-run-column--odd--2HFYaT0x {\n  background-color: #e2f4f8;\n}\n", ""]);
// Exports
exports.locals = {
	"lastRunColumn": "last-run-column--lastRunColumn--1ffU9lMQ",
	"even": "last-run-column--even--2i5Vwx_m",
	"odd": "last-run-column--odd--2HFYaT0x"
};
module.exports = exports;
